import { createApiAction } from '@app/packages/api/utils'
import type { ApiTelegramCode } from '@app/packages/api/v2/types/entities'

export const postTelegramCode = () =>
  createApiAction('postTelegramCode', dispatch => dispatch<{ data: ApiTelegramCode }>({ method: 'POST', endpoint: '/api/v2/telegram/code' }))
